import axios from "axios";
import store from '../store/index'
import router from "../router";
let baseUrl = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_HOST : process.env.VUE_APP_API_HOST_LOCAL;
const httpClient = axios.create({
    baseURL: baseUrl,
    // timeout: 20000,
    headers: {
        "Content-Type": "application/json",
        // anything you want to add to the headers
    }
});
const getAuthToken = () => localStorage.getItem('ptoken');

const authInterceptor = (config) => {
    // NProgress.start();
    config.headers['Authorization'] = `Bearer ${getAuthToken()}`;
    return config;
};

httpClient.interceptors.request.use(authInterceptor);
// interceptor to catch errors
const errorInterceptor = error => {
        // all the error responses
        console.log(error);
        // if (error === "") {
        // }
        if (error.code === 'ECONNABORTED') {
            toast.fire({
                title: 'Time out', icon: 'error'
            });
        } else {
            if (error.response) {
                switch (error.response.status) {
                    case 400:
                        toast.fire({
                            title: 'Something is wrong! [400]', icon: 'error'
                        });
                        break;
                    case 401: // authentication error, logout the user
                        toast.fire({
                            title: 'Unauthorized', icon: 'error'
                        });
                        store.commit('LOGOUT');
                        localStorage.removeItem('ptoken');
                        localStorage.removeItem('SMSSystem');
                        router.push({
                            name: "Login"
                        });
                        break;
                    case 403: // authentication error, logout the user
                        toast.fire({
                            title: 'Access Denied', icon: 'error'
                        });
                        localStorage.removeItem('ptoken');
                        localStorage.removeItem('SMSSystem');
                        router.push({
                            name: "Login"
                        });
                        break;
                    case 404:
                        toast.fire({
                            title: 'Not Found [404]', icon: 'error'
                        });
                        break;
                    case 500:
                        toast.fire({
                            title: 'Server issue', icon: 'error'
                        });
                        break;
                    default:
                        // console.error(error, error.message);
                        toast.fire({
                            title: 'Server Error', icon: 'error'
                        });
                }
            } else {
                toast.fire({
                    title: 'An Error Occured', icon: 'error'
                });
            }
        }
        return Promise.reject(error);
    }
;

// Interceptor for responses
const responseInterceptor = response => {
    switch (response.status) {
        case 200:
            toast.fire({
                title: 'Ok!', icon: 'success'
            });
            break;
    }
    return response;
};
httpClient.interceptors.response.use(
    response => responseInterceptor(response),
    error => errorInterceptor(error));
export default httpClient;